/**
 * Route Constants
 * 
 * Centralized route definitions for the application
 * All routes use kebab-case for consistency
 */

// Auth routes
export const ROUTES = {
  // Auth
  LOGIN: '/login',
  
  // Dashboard
  DASHBOARD: '/',
  
  // Guests
  GUESTS: '/guests',
  GUEST_DETAIL: '/guests/:id',
  GUEST_NEW: '/guests/new',
  GUEST_EDIT: '/guests/:id/edit',
  GUEST_SCHEDULE: '/guests/:id/schedule',
  
  // Nominations
  NOMINATIONS: '/nominations',
  NOMINATION_DETAIL: '/nominations/:id',
  NOMINATION_NEW: '/nominations/new',
  NOMINATION_EDIT: '/nominations/:id/edit',
  
  // Applications
  APPLICATIONS: '/applications',
  APPLICATION_DETAIL: '/applications/:id',
  APPLICATION_NEW: '/applications/new',
  APPLICATION_EDIT: '/applications/:id/edit',
  
  // Target Guests
  TARGET_GUESTS: '/target-guests',
  TARGET_GUEST_DETAIL: '/target-guests/:id',
  TARGET_GUEST_NEW: '/target-guests/new',
  TARGET_GUEST_EDIT: '/target-guests/:id/edit',
  TARGET_GUEST_CONVERT: '/target-guests/:id/convert',
  
  // Map
  MAP: '/map',
  
  // Settings
  SETTINGS: '/settings',
  
  // Error routes
  UNAUTHORIZED: '/unauthorized',
  NOT_FOUND: '*'
};

/**
 * Generate a route with parameters
 * 
 * @param route Route pattern with :param placeholders
 * @param params Object with parameter values
 * @returns Route with parameters replaced
 */
export const generateRoute = (route: string, params: Record<string, string>): string => {
  let result = route;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
};

export default ROUTES;
